/**
 * Service for handling activity-related operations
 */
export default {
  /**
   * Get all activities with pagination
   * @param {Object} store - Vuex store
   * @param {Object} params - Request parameters
   * @returns {Promise} - Request response
   */
  getAllActivities(store, params) {
    const { type, sortDate, limit, cursor, from_archival } = params;
    const payload = {
      type,
      sortDate,
      limit,
    };
    if (cursor) {
      payload.cursor = cursor;
    }
    if (from_archival) {
      payload.from_archival = true;
    }
    return store
      .dispatch("user/new_activities", payload)
      .then((res) => {
        if (!res || res.error) {
          return { success: false };
        }

        return {
          success: true,
          next_cursor: store.getters["user/activities"].next_cursor,
        };
      });
  },

  /**
   * Get default rider data
   * @param {Object} store - Vuex store
   * @param {Function} callback - Callback for processing data
   * @returns {Promise} - Request promise
   */
  getDefaultData(store, callback) {
    return store.dispatch("user/get_rider_default_data").then(() => {
      if (callback && typeof callback === "function") {
        callback(store.getters["user/rider_default_data"]);
      }
    });
  },

  /**
   * Get single activity data
   * @param {Object} store - Vuex store
   * @param {string} fileId - Activity file ID
   * @param {Function} processData - Function to process the data
   * @returns {Promise} - Request promise
   */
  getSingleActivity(store, fileId, processData) {
    return store.dispatch("user/get_single_ride_data", { fileId }).then(() => {
      const activityData = store.getters["user/single_ride_data"];
      if (activityData.detail.length > 0) {
        if (processData && typeof processData === "function") {
          return processData(activityData);
        }
        return { success: true };
      } else {
        return { success: false, message: "Unable to fetch activity detail." };
      }
    });
  },

  /**
   * Download activity file
   * @param {Object} store - Vuex store
   * @param {string} fileId - Activity file ID
   * @returns {Promise} - Request promise
   */
  downloadFile(store, fileId) {
    return store.dispatch("user/downloadFile", { fileId }).then(({ data }) => {
      const docUrl = document.createElement("a");
      docUrl.href = data;
      docUrl.setAttribute("download", fileId);
      document.body.appendChild(docUrl);
      docUrl.click();
      return { success: true };
    });
  },

  /**
   * Get comparison data for activities
   * @param {Object} store - Vuex store
   * @param {Array} activityFileIds - List of activity file IDs to compare
   * @returns {Promise} - Request promise
   */
  getCompareData(store, activityFileIds) {
    return store.dispatch("user/get_compare_data", {
      activityFileIds,
    });
  },
};
